'use strict';

const SELECTORS = {
  userLogged: '.js-logged',
  dropdownButton: '.js-dropdown-button',
  dropdown: '.js-dropdown-menu'
};

const CLASSES = {
  show: 'show'
};

class DropdownOverlay {
  constructor() {
    this.initEvents();
  }

  initEvents() {
    const closeOnEscape = (e) => {
      if (e.key === 'Escape') {
        $(SELECTORS.dropdown).removeClass(CLASSES.show);
        document.removeEventListener('keydown', closeOnEscape);
      }
    };

    $(document).on('mouseenter', SELECTORS.userLogged, (e) => {
      if (window.isMobile) {
        return;
      }
      $(SELECTORS.dropdown).addClass(CLASSES.show);
      document.addEventListener('keydown', closeOnEscape);
    });

    $(document).on('mouseleave', SELECTORS.userLogged, (e) => {
      const isUserLoggedHovering = $(e.currentTarget).is(':hover');
      const isDropdownHovering = $(SELECTORS.dropdown).is(':hover');

      if (!isUserLoggedHovering && !isDropdownHovering) {
        $(SELECTORS.dropdown).removeClass(CLASSES.show);
        document.removeEventListener('keydown', closeOnEscape);
      }
    });
  }
}

const dropdownOverlayInstance = new DropdownOverlay();
